var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalleticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    y: 0.0478516,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#7770E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20.0479V19.2479C29 18.1277 29 17.5677 28.782 17.1399C28.5903 16.7635 28.2843 16.4576 27.908 16.2658C27.4802 16.0479 26.9201 16.0479 25.8 16.0479H11M29 20.0479V24.0479M29 20.0479H27C25.8954 20.0479 25 20.9433 25 22.0479C25 23.1524 25.8954 24.0479 27 24.0479H29M29 24.0479V24.8479C29 25.968 29 26.528 28.782 26.9558C28.5903 27.3322 28.2843 27.6381 27.908 27.8299C27.4802 28.0479 26.9201 28.0479 25.8 28.0479H14.2C13.0799 28.0479 12.5198 28.0479 12.092 27.8299C11.7157 27.6381 11.4097 27.3322 11.218 26.9558C11 26.528 11 25.968 11 24.8479V16.0479M26 16.0479V15.2479C26 14.1277 26 13.5677 25.782 13.1399C25.5903 12.7635 25.2843 12.4576 24.908 12.2658C24.4802 12.0479 23.9201 12.0479 22.8 12.0479H14.2C13.0799 12.0479 12.5198 12.0479 12.092 12.2658C11.7157 12.4576 11.4097 12.7635 11.218 13.1399C11 13.5677 11 14.1277 11 15.2479V16.0479",
    stroke: "#F7F7FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalleticon);
export default __webpack_public_path__ + "static/media/walleticon.73db776041b1cdbfe3b3115e19cb08e2.svg";
export { ForwardRef as ReactComponent };